import { createSlice } from "@reduxjs/toolkit";

const numberToWords = (s) => {
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    var th = ['', 'thousand', 'million', 'billion', 'trillion'];
    var dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    var tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    var tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    s = s.toString();
    s = s.replace(/[\, ]/g, '');
    if (s != parseFloat(s)) return 'not a number';
    var x = s.indexOf('.');
    if (x == -1) x = s.length;
    if (x > 15) return 'too big';
    var n = s.split('');
    var str = '';
    var sk = 0;
    for (var i = 0; i < x; i++) {
        if ((x - i) % 3 == 2) {
            if (n[i] == '1') {
                str += tn[Number(n[i + 1])] + ' ';
                i++;
                sk = 1;
            }
            else if (n[i] != 0) {
                str += tw[n[i] - 2] + ' ';
                sk = 1;
            }
        }
        else if (n[i] != 0) {
            str += dg[n[i]] + ' ';
            if ((x - i) % 3 == 0) str += 'hundred ';
            sk = 1;
        }

        if ((x - i) % 3 == 1) {
            if (sk) str += th[(x - i - 1) / 3] + ' ';
            sk = 0;
        }
    }
    if (x != s.length) {
        var y = s.length;
        str += 'point ';
        for (var i = x + 1; i < y; i++) str += dg[n[i]] + ' ';
    }
    return capitalizeFirstLetter(str.replace(/\s+/g, ' '));
}

const cardPreviewSlice = createSlice({
    name: "cardPreview",
    initialState: {
        IsEcard: false,
        ShowCardGallery: false,
        ShowVerseGallery: false,
        ShowCustomVerseInput: false,
        HasMoreCards: false,
        HasMoreVerses: false,
        OccasionLoading: false,
        OccasionLoaded: false,
        ConfiguratorSummary: '',
        ConfiguratorImage: '',
        Occasion: {},
        CardHeading: 'Seraphic Mass Association\nCertificate of Perpetual Enrollment',
        CardIntention: '',
        CardMassDate: '',
        CardSignature: '',
        EnvelopeRecipientAddress: '',
        EnvelopeReturnAddress: '',
        SelectedCard: {
            Id: 0,
            Description: '',
            InsideImage: '',
            CoverImage: '',
            PictureCode: '',
            EnvelopeBackgroundImage: ''
        },
        SelectedVerse: {
            Id: 0,
            VerseImage: '',
            VerseCode: ''
        },
        CustomVerse: ''
    },
    reducers: {
        setOccasionLoading: (state, action) => {
            state.OccasionLoading = true;
            state.OccasionLoaded = false;
        },
        setSelectedOccasionState: (state, action) => {
            const selectedOccasion = action.payload;

            state.Occasion = selectedOccasion;

            if(selectedOccasion.DefaultCard) {
                state.SelectedCard.Id = selectedOccasion.DefaultCard.Id;
                state.SelectedCard.Description = selectedOccasion.DefaultCard.Description;
                state.SelectedCard.InsideImage = selectedOccasion.DefaultCard.InsideBackgroundImage;
                state.SelectedCard.CoverImage = selectedOccasion.DefaultCard.CoverImage;
                state.SelectedCard.EnvelopeBackgroundImage = selectedOccasion.DefaultCard.EnvelopeBackgroundImage;
                state.SelectedCard.PictureCode = selectedOccasion.DefaultCard.PortfolioPictureCode;
                state.SelectedVerse.VerseCode = selectedOccasion.DefaultVerse.PortfolioVerseCode;
                state.SelectedVerse.VerseImage = selectedOccasion.DefaultVerse.VerseImage;
            }

            state.OccasionLoading = false;
            state.OccasionLoaded = true;
        },
        setSelectedCard: (state, action) => {
            const selectedCard = action.payload;

            state.SelectedCard.Id = selectedCard.Id;
            state.SelectedCard.Description = selectedCard.Description;
            state.SelectedCard.InsideImage = selectedCard.InsideBackgroundImage;
            state.SelectedCard.CoverImage = selectedCard.CoverImage;
            state.SelectedCard.EnvelopeBackgroundImage = selectedCard.EnvelopeBackgroundImage;
            state.SelectedCard.PictureCode = selectedCard.PortfolioPictureCode;
        },
        setSelectedVerse: (state, action) => {
            const selectedVerse = action.payload;

            state.SelectedVerse.Id = selectedVerse.Id;
            state.SelectedVerse.VerseCode = selectedVerse.PortfolioVerseCode;
            state.SelectedVerse.VerseImage = selectedVerse.VerseImage;

            state.CustomVerse = '';
        },
        setCustomVerse: (state, action) => {
            state.CustomVerse = action.payload;

            state.SelectedVerse.Id = 0;
            state.SelectedVerse.VerseCode = '';
            state.SelectedVerse.VerseImage = '';
        },
        setFieldFocus: (state, action) => {
            state.FocusedField = action.payload;
        },
        setFieldValue: (state, action) => {
            state[action.payload.key] = action.payload.value;
            //console.log(action.payload.key + ' | ' + action.payload.value);
        },
        setMassDate: (state, action) => {
            const massQuantity = action.payload.massQuantity;
            const offeringTime = action.payload.offeringTime;
            const massDate = action.payload.massDate;
            state.CardMassDate = massDate;
        },
        setMassQuantity: (state, action) => {
            const massQty = Number(action.payload);
            //console.log(massQty);
            if(massQty === 1) {
                state.CardHeading = 'The Holy Sacrifice of the Mass\nwill be offered for';
            } else {
                state.CardHeading = numberToWords(massQty) + ' Masses\nwill be offered for';
            }
        },
        setShowCardGallery: (state, action) => {
            state.ShowCardGallery = action.payload;
        },
        setShowVerseGallery: (state, action) => {
            state.ShowVerseGallery = action.payload;
        },
        setShowCustomVerseInput: (state, action) => {
            state.ShowCustomVerseInput = action.payload;
        },
        setEnvelopeRecipientAddress: (state, action) => {
            const values = action.payload;
            let recipientAddress = '';
            if(values.title) recipientAddress += values.title + ' ';
            recipientAddress += values.firstName + ' ' + values.lastName + '\n';
            recipientAddress += values.address1 + '\n';
            if(values.address2) recipientAddress += values.address2 + '\n';
            if(values.country === 'USA') {
                recipientAddress += values.city + ' ' + values.state + ' ' + values.postalCode;
            } else if(values.country === 'Canada') {
                recipientAddress += values.city + ' ' + values.province + ' ' + values.postalCode + '\n' + values.country;
            } else {
                recipientAddress += values.city + ' ' + values.postalCode + '\n' + values.country;
            }
            state.EnvelopeRecipientAddress = recipientAddress;
        },
        setEnvelopeReturnAddress: (state, action) => {
            const values = action.payload;
            let returnAddress = '';
            if(values.title) returnAddress += values.title + ' ';
            returnAddress += values.firstName + ' ' + values.lastName + '\n';
            returnAddress += values.address1 + '\n';
            if(values.address2) returnAddress += values.address2 + '\n';
            if(values.country === 'USA') {
                returnAddress += values.city + ' ' + values.state + ' ' + values.postalCode;
            } else if(values.country === 'Canada') {
                returnAddress += values.city + ' ' + values.province + ' ' + values.postalCode + '\n' + values.country;
            } else {
                returnAddress += values.city + ' ' + values.postalCode + '\n' + values.country;
            }
            state.EnvelopeReturnAddress = returnAddress;
        },
        clearEnvelopeReturnAddress: (state, action) => {
            state.EnvelopeReturnAddress = '';
        }
    }
});

export const cardPreviewActions = cardPreviewSlice.actions;

export default cardPreviewSlice;